export default "__VITE_ASSET__DGboTvrF__"